import { createSelector } from 'reselect'

const interactiveVideoData = state => state.interactiveVideoCreation

const getBreakpointUidFromBreakpointActivityUid = breakpointActivityUid => createSelector(
	[ interactiveVideoData ],
	interactiveVideoData => {
		const breakpoints = interactiveVideoData.media.breakpoints

		for (let i = 0; i < breakpoints.length; i++) {

			for (let j = 0; j < breakpoints[i].activities.length; j++) {
				const activity = breakpoints[i].activities[j]

				if (activity.uid === breakpointActivityUid) {
					return breakpoints[i].uid
				}
			}

		}
	}
)

export default getBreakpointUidFromBreakpointActivityUid
